<ez-main-layout [theme]="Themes.WHITELABEL">
  <ez-banner>
    <span ngProjectAs="title">Willkommen</span>
    <span ngProjectAs="subtitle">Ihre Daten wurden bereits abgesendet</span>
  </ez-banner>
  <p>Wir haben Ihre Daten bereits erhalten. Ein erneutes Absenden der Daten ist nicht möglich.</p>
  <p>Vielen Dank für die bereits erfolgte Übermittlung.</p>
</ez-main-layout>
